export default "/images/vendor/flag-icons/flags/4x3/bl.svg?67c5ef35e02e55d24b8c4e94cf8a661f";